import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import useList              from "Dashboard/Hooks/List";

// Components
import NotificationView     from "./NotificationQueueView";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import Filter               from "Dashboard/Components/Filter/Filter";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";



/**
 * The Notification Queue List
 * @returns {React.ReactElement}
 */
function NotificationList() {
    const { load, loadFilter } = useList("notificationQueue");

    const data = Store.useState("notificationQueue");
    const { loading, list, total, filters, sort } = data;

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Do the Render
    return <Main>
        <Header message="NOTIFICATION_QUEUE_NAME" icon="notification" />
        <Content>
            <Filter
                onFilter={loadFilter}
                values={filters}
                hasSearch
            />
            <Table
                fetch={load}
                sort={sort}
                none="NOTIFICATION_QUEUE_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="createdTime"    message="GENERAL_CREATED_AT_FEM" minWidth="160" maxWidth="160" />
                    <TableHeader field="credentialName" message="GENERAL_SEND_TO"        />
                    <TableHeader field="title"          message="GENERAL_TITLE"          />
                    <TableHeader field="isError"        message="GENERAL_RESULT"         maxWidth="90" />
                    <TableHeader field="sentTime"       message="GENERAL_SENT_AT_FEM"    minWidth="160" maxWidth="160" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.notificationID} elemID={elem.notificationID}>
                        <TableCell message={elem.createdTimeText} />
                        <TableCell message={elem.credentialName}  />
                        <TableCell message={elem.title}           />
                        <TableCell message={elem.resultText}      className={elem.resultClass} />
                        <TableCell message={elem.sentTimeText}    />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction}>
                    <TableAction action="VIEW" message="NOTIFICATION_QUEUE_VIEW_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <NotificationView
            open={action.isView}
            elemID={elemID}
            onClose={endAction}
        />
    </Main>;
}

export default NotificationList;
